/**
 * Stable CSS class names for E2E — Customer account status.
 */
export const CAS = {
    page: 'customer-account-status-page',
    formColumn: 'customer-account-status-page__form-column',
    fieldAccountStatus: 'customer-account-status-field--account-status',
    inputSelectStatus: 'customer-account-status-input--select-status',
    inputTextfieldReason: 'customer-account-status-input--textfield-reason',
    formActions: 'customer-account-status-page__form-actions',
    inputButtonSend: 'customer-account-status-input--button-send',
    historyColumn: 'customer-account-status-page__history-column',
    historyGridInner: 'customer-account-status-page__history-grid-inner',
    datagrid: 'customer-account-status-page__datagrid',
} as const;

export const casCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
